import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Typography,
  notification,
  Menu,
  Input,
  Dropdown,
  Switch
} from "antd";

import { SearchOutlined , DownOutlined } from "@ant-design/icons";

// Images
import { useEffect, useState } from "react";
import { getUserById, getDrivers, toggleUserStatus } from "../api/user.service";
import EditUserFormModal from "../components/forms/user/EditUserFormModal";
import AddUserFormModal from "../components/forms/user/AddUserFormModal";

export const getRoleTitle = (record) => {
  return record.role == 1 ? 'SUPER ADMIN' : record.role == 2 ? 'MANAGER' : record.role == 3 ? 'AGENT' : record.role == 4 ? 'DRIVER' : 'N/A'
}

function Drivers() {
  const [users, setUsers] = useState([]); // State to store user data

  useEffect(() => {
    fetchUsers();
  }, []); // Runs only once when the component mounts

  const onChangeStatus = async (checked, record) => {
    let updated = {
      ...record,
      status: checked ? 1 : 0
    }

    try {
      await toggleUserStatus(updated)
      notification.success({
        message: 'Status updated'
      })
      fetchUsers();
    } catch (error) {
      notification.error({
        message: 'Operation failed'
      })
    }
  };


  // Helper function to add search functionality for a column
  const getColumnSearchProps = (dataIndex, placeholder, renderField) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${placeholder}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => confirm()}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const recordValue = renderField ? renderField(record) : record[dataIndex];
      return recordValue
        ? recordValue.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
  });

  const columns = [
    {
      title: "USER",
      dataIndex: "name",
      key: "name",
      width: "20%",
      ...getColumnSearchProps("name", "User"),
    },
    {
      title: "PHONE",
      dataIndex: "mobile",
      key: "phone",
      width: "20%",
      ...getColumnSearchProps("phone", "Phone"),
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
      width: "20%",
      ...getColumnSearchProps("email", "Email"),
    },
    {
      title: "ROLE",
      dataIndex: "role",
      key: "role",
      width: "20%",
      ...getColumnSearchProps("role", "Role", (record) => getRoleTitle(record)),
      render: (text, record) => <div>{getRoleTitle(record).charAt(0).toUpperCase() + getRoleTitle(record).slice(1).toLowerCase()}</div>,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      width: "20%",
      render: (text,record)=>{
        return (
          <div>
            <Switch
              defaultChecked={record.status == 1} // Set initial checked state
              onChange={(checked) => onChangeStatus(checked, record)}
            />
          </div>
        )
      }
    },
    {
      title: "ACTIONS",
      width: "25%",
      render: (text, record) => {
        const menu = (
          <Menu>
            <Menu.Item key="view" onClick={() => getUserData(record.id, true)}>
              View
            </Menu.Item>
            <Menu.Item key="edit" onClick={() => getUserData(record.id)}>
              Edit
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu}>
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              Tasks <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [UserData, setUserData] = useState(null);
  const [isViewOnly, setisViewOnly] = useState(false);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const data = await getDrivers();
      setUsers(data?.data || []); // Set the fetched Drivers data
    } catch (err) {
      notification.error({ message: 'Failed to fetch Drivers' });
      setError('Failed to fetch Drivers');
    } finally {
      setLoading(false);
    }
  };

  const getUserData = async (id, isViewOnly = false) => {
    setisViewOnly(isViewOnly)
    const data = await getUserById(id);
    setUserData(data.data);
    setIsModalOpenEdit(true);
  }

  useEffect(() => {
    fetchUsers();
  }, []);

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOkEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleCancelEdit = () => {
    setIsModalOpenEdit(false);
  };


  return (
    <>
      {UserData && <EditUserFormModal isViewOnly={isViewOnly} UserData={UserData} fetchAllUsers={fetchUsers} handleCancel={handleCancelEdit} handleOk={handleOkEdit} isModalOpen={isModalOpenEdit} setIsModalOpen={setIsModalOpenEdit} />}
      <AddUserFormModal fetchAllUsers={fetchUsers} handleCancel={handleCancel} handleOk={handleOk} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <div className="mb-3 flex justify-end">
        <Button type="primary" onClick={showModal}>
          Add Driver
        </Button>
      </div>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Drivers Table"
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={users}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Drivers;
